import React, { useEffect } from "react";
import styled from "styled-components";
import UserDetail from './UserDetail'


const Username = styled.div`
    font-size: 17px;
    font-family: 'Poppins';
`;

const ProfileDetailsWrapper = styled.div`    
    font-size: 17px;
    font-family: 'Poppins';
    display: flex;
    flex-direction: row;
`;

export default function ProfileDetails({user}){
    return (
      <div style={{display: 'flex', flexDirection: 'row'}}>
          <img style={{width: 75, height: 75, borderRadius: 5}} src={user.pictureUri} />
          <div style={{display: 'flex', flexDirection: 'column', marginLeft: 14}}>
            <Username>@{user.username}</Username>
            <ProfileDetailsWrapper>
                <UserDetail title={'Videos'} value={user.totalVideos}/>
                <UserDetail title={'Followers'} value={user.followers}/>
                <UserDetail title={'Following'} value={user.following}/>
            </ProfileDetailsWrapper>
          </div>
      </div>
    );
  };
